// @flow
import React from 'react';

import { StyledH4 } from '../../../../../presentational/headings/StyledH4';

export const SPMetricLevelDiscountLabelContainer = () => (
  <StyledH4 text="Custom Discounts - ( Only admins can edit )" />
);
